// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-coupon__icon{fill:#aeb4c2}.app-coupon__notification{margin-top:24px}.app-coupon input{text-transform:uppercase}.app-coupon input::-moz-placeholder{text-transform:none}.app-coupon input:-ms-input-placeholder{text-transform:none}.app-coupon input::placeholder{text-transform:none}", ""]);
// Exports
module.exports = exports;
